export const TYPOGRAPHY_TYPES = [
  'displayLg',
  'displayMd',
  'displaySm',
  'title3XL',
  'title2XL',
  'titleXL',
  'titleLg',
  'titleMd',
  'titleBase',
  'titleSm',
  'titleXs',
  'bodyMd',
  'bodyBase',
  'bodySm',
  'bodyXs',
  'bodyXXs',
  'uiBase',
  'uiSm',
  'uiXs',
] as const;

export type TypographyType = (typeof TYPOGRAPHY_TYPES)[number];

export const TYPOGRAPHY_ELEMENTS = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'span',
] as const;

export type TypographyElement = (typeof TYPOGRAPHY_ELEMENTS)[number];

export const TYPOGRAPHY_FONTS = ['nort', 'robotoMono'] as const;

export type TypographyFont = (typeof TYPOGRAPHY_FONTS)[number];

export const TYPOGRAPHY_COLORS = [
  'default',
  'soft',
  'disabled',
  'inverse',
  'primary',
  'success',
  'warning',
  'critical',
  'link',
] as const;

export type TypographyColor = (typeof TYPOGRAPHY_COLORS)[number];
